import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { APP_CONFIG, IAppConfig } from '@tcc-mono/shared/app-config';
import { BaseService } from '@tcc-mono/shared/data-access';
import { RideAnimal } from '@tcc-mono/vandijk/shared/data-access/models';

@Injectable({
  providedIn: 'root'
})
export class RideAnimalService extends BaseService<RideAnimal> {
  public constructor(
    _http: HttpClient,
    @Inject(APP_CONFIG) appConfig: IAppConfig
  ) {
    super(_http, appConfig);
    this.path = 'api/ride-animals';
  }
}
